import DetailViewContentElement from "~/models/detailView/elements/detailViewContentElement";
import {FormListSortColumn} from "../enums/formListSortColumn";
import {FormListFormDropownOptionsConfig} from "../enums/formListFormDropownOptionsConfig";

/**
 *  linked_forms_collection is an abstraction meant to help populate the pills
 *  associated with the FormList in the builder. It acts as a simple repo
 *  to load the form shadows from the back end, then keep track of all the
 *  possible form shadows that the user may select/unselect during builder
 *  editing session
 */
export default class FormList extends DetailViewContentElement {
  linked_form_ids: Array<string>;
  linked_forms_collection: Array<{title: string, id: string, total_submission_count?: number}>;
  record_display_limit: number;
  default_sort_by_column: FormListSortColumn;
  default_sort_direction: 1 | -1;
  display_filters_after_num: number;
  enable_filters_when_embedded: boolean;
  filter_form_drodpown_options_config: FormListFormDropownOptionsConfig;
  labelTag = "h4";

  constructor(){
    super();
    this.defineProperty('default_sort_by_column', FormListSortColumn.SubmissionDate);
    this.defineProperty('default_sort_direction', -1);
    this.defineProperty('display_filters_after_num', 5);
    this.defineProperty('enable_filters_when_embedded', true);
    this.defineProperty('filter_form_drodpown_options_config', FormListFormDropownOptionsConfig.OnlyFormsWithSubmissions);
    this.defineProperty('record_display_limit', 5);
    this.defineProperty('linked_forms_collection', []);
  }

  get linked_forms() {
    return this.linked_form_ids.map(id => {
      return this.linked_forms_collection.find(shadowForm => shadowForm.id === id)
    });
  }

  get UNTRACKED_PROPERTIES(): string[] {
    return ["linked_forms_collection"];
  }

  get TRACKED_ARRAYS(): string[]{
    return [
      'linked_form_ids',
    ]
  }
}